import {Link, RelativeTime} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/styled-react'
import {Box} from '@primer/styled-react'
import {Tooltip} from '@primer/react/next'
import {userHovercardPath} from '@github-ui/paths'
import {GitHubAvatar} from '@github-ui/github-avatar'

import styles from './UpdatedBy.module.css'

interface UpdatedByProps {
  user?: {
    login: string
    name: string
    path: string
    avatarUrl: string
  }
  updatedAt: string
  deletedAt?: string
  sx?: BetterSystemStyleObject
}

export function UpdatedBy({user, updatedAt, deletedAt = undefined, sx}: UpdatedByProps) {
  return (
    <Box
      sx={{
        ...sx,
      }}
      className={styles.Container}
    >
      {user &&
        (user.path.startsWith('/apps/') ? (
          <Tooltip text={user.name}>
            <Link href={user.path} className={styles.UserLink}>
              <GitHubAvatar
                aria-label={user.login}
                src={user.avatarUrl}
                alt={user.login}
                size={16}
                square
                className={styles.GitHubAvatar}
              />
            </Link>
          </Tooltip>
        ) : (
          <Link
            href={user.path}
            data-hovercard-url={userHovercardPath({owner: user.login})}
            className={styles.UserLink}
          >
            <GitHubAvatar
              aria-label={user.login}
              src={user.avatarUrl}
              alt={user.login}
              size={16}
              square={false}
              className={styles.GitHubAvatar}
            />
          </Link>
        ))}
      {deletedAt && <span>Deleted</span>}&nbsp;
      <RelativeTime datetime={deletedAt || updatedAt} tense="past" />
    </Box>
  )
}
